import React from "react";
import { useState } from "react";
import Button from "./DefaultButton";

const ButtonGroup = ({
  primaryText,
  primaryClick,
  primaryType,
  secondaryClick,
  secondaryText,
  secondaryType,
  styles,
}) => {
  return (
    <div className="flex gap-2" style={{ ...styles }}>
      <Button variant="secondary" onClick={secondaryClick} type={secondaryType}>
        {secondaryText}
      </Button>
      <Button variant="primary" onClick={primaryClick} type={primaryType}>
        {primaryText}
      </Button>
    </div>
  );
};

export default ButtonGroup;
